const MOBILE_NAV_HEIGHT = 58;
const MENU_PADDING = '20px 24px';
export { MENU_PADDING, MOBILE_NAV_HEIGHT };
//# sourceMappingURL=constants.js.map
